<template>
  <div>
    <v-form>
      <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>

      <v-card-title>
        <span class="title">
          <v-icon class="hidden-xs-only">timer_off</v-icon>
          {{$t('timeNotWorked')}}
        </span>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          :label="$t('search')"
          single-line
          hide-details
          v-model="search"
        ></v-text-field>
      </v-card-title>

      <div class="center-full" v-if="loading">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>

      <v-data-table
        v-bind:headers="headers"
        v-bind:items="items"
        v-bind:search="search"
        hide-default-footer
        v-if="!loading"
      >
        <template v-slot:item.licenseRemuneratedDateStart="{ item }">
          <v-row>
            <v-col v-if="item.licenseRemuneratedDateStart">
              De {{ item.licenseRemuneratedDateStart | formatToDate }},
              hasta {{ item.licenseRemuneratedDateEnd | formatToDate }}
            </v-col>
            <v-col v-else>
              Sin remuneración
            </v-col>
          </v-row>
        </template>
        <template v-slot:item.licenseDateStart="{ item }">
          <v-row>
            <v-col>
              {{ item.licenseDateStart | formatToDate }}
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-form>

    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn fixed dark fab bottom right color="accent" @click="get()" v-on="on">
          <v-icon>refresh</v-icon>
        </v-btn>
      </template>
      <span>Refrescar</span>
    </v-tooltip>
  </div>
</template>
<script>
import { i18n } from "@/i18n";
import { responseException } from "@/assets/js/common";
import { getToken } from "@/assets/js/shared/utils.js";
export default {
  data() {
    return {
      loading: false,
      search: "",
      headers: [
        {
          text: i18n.tc("type", 1),
          value: "licenseKindName"
        },
        {
          text: i18n.t("license"),
          value: "licenseDateStart",
          align: "center"
        },
        {
          text: i18n.t("remunerated"),
          value: "licenseRemuneratedDateStart",
          align: "center",
          class: "hidden-xs-only"
        }
      ],
      items: []
    };
  },
  methods: {
    get: function() {
      this.loading = true;
      this.$http.get(`hrm/licenses/?personId=${getToken().personId}`).then(
        response => {
          this.items = response.body;
          this.loading = false;
        },
        response => {
          this.$swal({
            icon: 'error',
            title: this.$t('errorOcurred'),
            text: responseException(response)
          })
          this.loading = false;
        }
      );
    }
  },
  mounted: function() {
    this.get();
  }
};
</script>
